//campaign analytics

import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { getDate } from "../../utils/datemaker";
import CustomPaginator from "../../components/CustomPaginator";
import { useEffect, useState, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Text } from "../../components/Text";
import { Toast } from "primereact/toast";

import {
  getCampaigns,
  changePage,
  changelimit,
} from "../../reducers/campaignSlice";
import DebounceSearch from "../../components/common/DebounceSearch";
import DateRangePicker from "../../components/common/DateRangePicker";
import "./tabStyles.css";
import { useNavigate } from "react-router";
import { CustomButton } from "../../components/CustomButton";
import { resetSelectedTemplate } from "../../reducers/templateReducer/templateSlice";
import { resetBroadcast } from "../../reducers/ShareMessage/messageSlice";
import { ReactComponent as ClockIcon } from "../../assets/svgIcons/clock.svg";
import { ReactComponent as ClockHoldIcon } from "../../assets/svgIcons/clockhold.svg";
import { resetSelectedProductBlist } from "../../reducers/productTableSlice";
import { DeleteAlert } from "../../components/Alert/DeleteAlert";
import TableActionsContainer from "../../components/CustomTable/TableActionsContainer";
import EllipsisText from "../../components/common/EllipsisText/indix";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";
import { ReactComponent as DocIcon } from "../../assets/docPreview.svg";
import { ReactComponent as VideoPreview } from "../../assets/videoPreview.svg";
import { updatecustomers } from "../../reducers/customerTableSlice";
import { useLayout } from "../../context/LayoutContext";
import { refineMessage } from "../../utils/templateUtils";
import CampaignRowAnalytics from "./CampaignRowAnalytics";
import CampScheduleTime from "../../components/CampScheduleTime";
import ImageGallary from "../../components/common/ImageGallary";
import modulesName from "../../roles/modulesName";
import permissions from "../../roles/permissions";
import * as XLSX from "xlsx";
import axiosInstance from "../../api/axios.instance";
import HelpVideoButton from "../../utils/YoutubeLinks";

ChartJS.register(ArcElement, Tooltip, Legend);

const CampaignTable = () => {
  const {
    campaignData,
    campaignLoading,
    page,
    limit,
    campaignType,
    campaignCount,
    selectedCampaignId,
    campaignTab,
  } = useSelector((state) => state.campaign);

  const { userSub, accesskey } = useSelector((state) => state.authenticate);
  const [dateRange, setDateRange] = useState({ fromDate: "", toDate: "" });
  const [inputValue, setInputValue] = useState("");
  const [displayAlertDelete, setDisplayAlertDelete] = useState(false);
  const { toast, setLoading } = useLayout(null);
  const toastRef = useRef(null);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const successRateBodyTemplate = (data) => {
    return (
      <div className="flex gap-2 justify-content-between align-items-center w-12 ">
        {data.Type === "ScheduledCampaign" && (
          <div>
            {!(data.hold === "1" || data.hold === true) ? (
              <ClockIcon />
            ) : (
              <ClockHoldIcon />
            )}
          </div>
        )}
        {data.Type === "ScheduledCampaign" && (
          <CampScheduleTime isHold={data?.hold} nextRun={data?.nextRun} />
        )}
        {data.Type === "Campaign" && (
          <CampaignRowAnalytics campaignDetails={data} />
        )}
      </div>
    );
  };

  const handleDateRangeFrom = (newDate) => {
    setDateRange((prev) => ({
      ...prev,
      fromDate: newDate,
    }));
  };

  const handleDateRangeTo = (newDate) => {
    setDateRange((prev) => ({
      ...prev,
      toDate: newDate,
    }));
  };

  const mediaBody = (rowData) => {
    const continerStyle = {
      width: "auto",
      maxHeight: "50px",
      aspectRatio: "16/9",
    };
    const { campaignType, templateType, variables } = rowData;

    if (campaignType === "product") {
      let prodImages = [];
      rowData.productItems?.forEach((prod) => {
        if (prod?.images) prodImages.push(...prod.images);
      });

      return (
        <div
          className="flex justify-content-start align-items-center gap-2"
          style={continerStyle}
          onClick={(e) => e.stopPropagation()}
        >
          {prodImages.length > 0 ? <ImageGallary images={prodImages} /> : ""}
        </div>
      );
    }

    switch (templateType?.toLowerCase()) {
      case "video":
        return (
          <div className="flex justify-content-start align-items-center">
            <VideoPreview width="60" height="30" />
          </div>
        );
      case "image":
        return (
          <div
            className="flex justify-content-start"
            style={continerStyle}
            onClick={(e) => e.stopPropagation()}
          >
            <ImageGallary images={variables} />
          </div>
        );
      case "document":
        return (
          <div className="flex justify-content-start" style={continerStyle}>
            <a
              href={`${variables?.mediaUrl}`}
              target="_blank"
              onClick={(e) => e.stopPropagation()}
            >
              <DocIcon width="35" height="35" />
            </a>
          </div>
        );
      default:
        return <Text>_</Text>;
    }
  };

  const handleCampaignSelect = (campaign) => {
    if (campaign.Type === "ScheduledCampaign") navigate(`./s-${campaign.id}`);
    else navigate(`./${campaign.id}`);
  };

  const exportCampaignDataToExcel = async () => {
    try {
      const data = await Promise.all(
        campaignData.map(async (row) => {
          // Fetch analytics for each campaign
          const res = await axiosInstance.get(`/campaign/${row.id}/analytics`);
          const analytics = res.data;
          const stats = {
            sent: 0,
            delivered: 0,
            read: 0,
            replied: 0,
            optout: 0,
            failed: 0,
          };

          analytics?.forEach((item) => {
            stats[item.status] = item.count;
          });

          return {
            "Campaign Name": row.campaignName,
            "Conversations Count": row.conversationsCount,
            Date: getDate(row.createdAt),
            Message: refineMessage(row.variables, row.message),
            Sent: stats.sent,
            Delivered: stats.delivered,
            Read: stats.read,
            Replied: stats.replied,
            "Opt-out": stats["opt-out"],
            Failed: stats.failed,
          };
        }),
      );

      const worksheet = XLSX.utils.json_to_sheet(data);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "CampaignData");

      XLSX.writeFile(
        workbook,
        `Campaign_Data_${new Date().toISOString()}.xlsx`,
      );
      toast.current.show({
        severity: "success",
        summary: "Exported successfully",
      });
    } catch (err) {
      console.error("Export error:", err);
      toast.current.show({
        severity: "error",
        summary: "Export failed",
      });
    }
  };

  useEffect(() => {
    if (userSub.isUserSub) {
      let tzoffset = new Date().getTimezoneOffset() * 60000;
      const { fromDate, toDate } = dateRange;

      const paginationData = {
        page,
        limit,
        campaignType,
        startDate: fromDate
          ? new Date(fromDate - tzoffset).toISOString().substring(0, 10)
          : fromDate,
        endDate: toDate
          ? new Date(toDate - tzoffset).toISOString().substring(0, 10)
          : toDate,
        globalFilterValue: inputValue,
        schedule: campaignTab === "schedule",
      };

      if ((fromDate && !toDate) || (!fromDate && toDate)) return;

      dispatch(getCampaigns(paginationData))
        .unwrap()
        .catch((err) => {});
    }
  }, [
    page,
    limit,
    inputValue,
    dateRange,
    userSub.isUserSub,
    displayAlertDelete,
  ]);

  const deleteModule = () => (
    <DeleteAlert
      item="schedule"
      displayAlertDelete={displayAlertDelete}
      setDisplayAlertDelete={setDisplayAlertDelete}
      toast={toast}
    />
  );

  const runcampaign = () => {
    dispatch(resetBroadcast());
    dispatch(resetSelectedTemplate());
    dispatch(updatecustomers({ selectedCust: [] }));
    dispatch(resetSelectedProductBlist());
    navigate("/runcampaign/new");
  };

  useEffect(() => {
    setLoading(campaignLoading);
  }, [campaignLoading]);

  return (
    <div className="cp-10">
      <Toast ref={toastRef} />
      {displayAlertDelete && deleteModule()}
      <TableActionsContainer>
        <div className="flex justify-content-between align-items-center flex-wrap gap-3">
          <Text type={"heading"}>Campaign List</Text>
          <div className="flex gap-3 flex-wrap">
            <DateRangePicker
              fromDate={dateRange.fromDate}
              toDate={dateRange.toDate}
              handleFromDate={handleDateRangeFrom}
              handleToDate={handleDateRangeTo}
            />
            <DebounceSearch
              placeholder="Search Campaign"
              inputValue={inputValue}
              handleInputChange={(value) => setInputValue(value)}
            />
            <CustomButton
              varient="text"
              label="Export"
              icon="pi pi-file-excel"
              onClick={exportCampaignDataToExcel}
            />
            {accesskey[modulesName.CAMPAIGN]?.includes(permissions.CREATE) && (
              <CustomButton
                varient="filled"
                label="Start New Campaign"
                icon="pi pi-plus"
                onClick={runcampaign}
              />
            )}
          </div>
        </div>
      </TableActionsContainer>
      <HelpVideoButton name="campaigns" />
      {userSub.isUserSub && (
        <>
          <div className="mt-3">
            <DataTable
              value={campaignData}
              key="id"
              selectionMode="single"
              selection={selectedCampaignId}
              onSelectionChange={(e) => handleCampaignSelect(e.value)}
              className="skalebot-table"
              responsiveLayout="scroll"
              emptyMessage="No data found."
              columnResizeMode="expand"
              globalFilterFields={["date"]}
            >
              <Column
                field="campaignName"
                header="Campaign Name"
                bodyStyle={{ textTransform: "capitalize" }}
                style={{ maxWidth: "140px" }}
                body={(rowData) => <EllipsisText text={rowData.campaignName} />}
              />
              <Column
                field="conversationsCount"
                className="text-sm font-normal"
                style={{ minWidth: "80px", maxWidth: "100px" }}
                header="Conversations"
              />
              <Column
                field="createdAt"
                header="Date & Time"
                className="text-sm font-normal"
                style={{ minWidth: "110px" }}
                body={(rowData) => {
                  let date = getDate(rowData.createdAt)?.split(",");
                  return (
                    <div className="flex flex-column gap-2">
                      <div>{date[0]}</div>
                      <div>{date[1]}</div>
                    </div>
                  );
                }}
                bodyStyle={{ textTransform: "uppercase" }}
              />
              <Column
                field="message"
                header="Message"
                bodyStyle={{ minWidth: "200px", maxWidth: "250px" }}
                body={(rowData) => {
                  let message = refineMessage(
                    rowData.variables,
                    rowData.message,
                  );
                  return <EllipsisText text={message} />;
                }}
                style={{ minWidth: "40%" }}
              />
              <Column
                header="Campaign Resource"
                body={mediaBody}
                headerStyle={{ whiteSpace: "nowrap" }}
                style={{ width: "30ch" }}
              />
              <Column
                header={() => <div className="pl-4">Status</div>}
                style={{ width: "25ch" }}
                body={successRateBodyTemplate}
              />
            </DataTable>
          </div>

          <div className="mt-3">
            <TableActionsContainer>
              <div className="flex justify-content-end">
                <CustomPaginator
                  page={page}
                  limit={limit}
                  changelimit={changelimit}
                  totalRecords={campaignCount}
                  changePage={changePage}
                />
              </div>
            </TableActionsContainer>
          </div>
        </>
      )}
    </div>
  );
};

export default CampaignTable;
